import { render, staticRenderFns } from "./OperatorNoticeTemplate.vue?vue&type=template&id=52f00bd7&scoped=true"
import script from "./OperatorNoticeTemplate.vue?vue&type=script&lang=js"
export * from "./OperatorNoticeTemplate.vue?vue&type=script&lang=js"
import style0 from "./OperatorNoticeTemplate.vue?vue&type=style&index=0&id=52f00bd7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f00bd7",
  null
  
)

export default component.exports